/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
// @ts-ignore
import { Tooltip } from '@netbasequid/core'
import { useDisplayTheme } from 'hooks/useUiState'
import { Theme } from 'features/ui/types'
import { setAutoId, AutomationId } from 'utils/automationUtil'
import { Link } from 'react-router-dom'
import Separator from './Separator'

const Container = styled.div<{ mode: Theme }>`
  white-space: nowrap;
  overflow: hidden;
  padding-right: 4px;
  margin-right: auto;
  font-family: var(--large-font-family);
  font-size: ${sys.typescale[16].size};
  font-weight: ${sys.fontWeight.semibold};
  line-height: ${sys.typescale[16].lineHeight};
  color: ${({ mode }) => sys[mode].text.primary};
  display: flex;
  min-width: 164px;
`

const LinkBreadcrumb = styled(Link)<{ mode: Theme; to: string }>`
  flex-shrink: 0;
  text-decoration: none;
  cursor: pointer;
  color: ${({ mode }) => sys[mode].interaction.primary.default};
  &:hover {
    color: ${({ mode }) => sys[mode].interaction.primary.hover};
  }
  &:active {
    color: ${({ mode }) => sys[mode].interaction.primary.pressed};
  }
`

const LastBreadcrumb = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

interface Breadcrumb {
  title: string
  route?: string
  onClick?: () => void
}

interface BreadcrumbsProps {
  items: Breadcrumb[]
}

const Breadcrumbs = ({ items }: BreadcrumbsProps) => {
  const displayTheme = useDisplayTheme() as Theme

  return (
    <Container mode={displayTheme}>
      {items.reduce((acc, item, index) => {
        if (index === items.length - 1) {
          return [
            ...acc,
            <Separator key={`separator-${item.title}`} />,
            <Tooltip key={item.title} mode={displayTheme} enabled content={item.title}>
              <LastBreadcrumb {...setAutoId(`${AutomationId.actionList.breadcrumb}-${index}`)}>
                {item.title}
              </LastBreadcrumb>
            </Tooltip>
          ]
        }
        return [
          ...acc,
          index !== 0 && <Separator key={`separator-${item.title}`} />,
          <LinkBreadcrumb
            to={item.route ? item.route : ''}
            mode={displayTheme}
            key={item.title}
            onClick={item.onClick}
            {...setAutoId(`${AutomationId.actionList.breadcrumb}-${index}`)}>
            {item.title}
          </LinkBreadcrumb>
        ]
      }, [] as React.ReactNode[])}
    </Container>
  )
}

export default Breadcrumbs
